module.exports = __webpack_public_path__ + "img/prev.ecd0d46d.svg";